export class ConsultaDocumentacionInmueblesModel{

	constructor(		
        public id:MchInformacionEscrituraId,
		public cantidadCompradores:number,
		public vdescripcion:string,
        public nvalor:number,
        public vobservacion:string,
        public ncostos:number,
        public ndocumento:number,
        public ndocumentocostos:number,
        public nvalida:number,
        public nfacturada:number,
        public ncontabilizada:number,
        public nestado:string,
        public nestadoNota:string
        ){}        
}
       
export class MchInformacionEscrituraId{
	constructor(public vidEscritura:string, public cnumcont:string, public cprefijo:string){}
}



// WEBPACK FOOTER //
// D:/REPO/FacturacionWeb/src/app/main/content/ConsultaDocumentacionInmuebles/ConsultaDocumentacionInmuebles.model.ts